import { AxiosResponse } from 'axios'
import { api } from 'API'
import { IPracticeComponent, PracticeComponentType } from 'interfaces/practice-component'

// The shared `api` axios instance auto-stamps `?orgId=` from the active team;
// the server validates membership and derives the org scope from it. No orgId
// is ever sent in the body/query by these calls.

export interface ListPracticeComponentsParams {
  q?: string
  type?: PracticeComponentType
  sort?: 'mostUsed' | 'recent'
  skip?: number
  limit?: number
}

export interface ListPracticeComponentsResult {
  items: IPracticeComponent[]
  total: number
}

export async function listPracticeComponents(
  params: ListPracticeComponentsParams = {}
): Promise<ListPracticeComponentsResult> {
  const response: AxiosResponse = await api.get('/practice-components', { params })
  return response.data
}

export async function getPracticeComponentById(id: number): Promise<IPracticeComponent> {
  const response: AxiosResponse = await api.get(`/practice-components/${id}`)
  return response.data
}

export async function createPracticeComponent(body: {
  type: PracticeComponentType
  rootId: number
  name: string
  tags?: string[]
}): Promise<IPracticeComponent> {
  const response: AxiosResponse = await api.post('/practice-components', body)
  return response.data
}

export async function instantiatePracticeComponent(
  id: number,
  body: { parentType: 'linebalance' | PracticeComponentType; parentId: number; position: number }
): Promise<{ rootId: number; rootType: string }> {
  const response: AxiosResponse = await api.post(`/practice-components/${id}/instantiate`, body)
  return response.data
}

export async function updatePracticeComponent(
  id: number,
  body: { name?: string; tags?: string[] }
): Promise<void> {
  await api.patch(`/practice-components/${id}`, body)
}

export async function deletePracticeComponent(id: number): Promise<void> {
  await api.delete(`/practice-components/${id}`)
}
